import React, { ComponentProps } from 'react';
import { Box, Container, Flex, Text } from '@qga/roo-ui/components';

import ReadMoreText from '@shared/v2/components/ReadMoreText/ReadMoreText';

import Heading from '@/v2/../components/Heading';
import LinkButton from '@/v2/../components/LinkButton';
// Legacy
import useProcuredOffer from '@/v2/../components/PackagePage/hooks/useProcuredOffer';
import usePropertyContent from '@/v2/../hooks/usePropertyContent';
import htmlToReact from '@/v2/../utils/htmlToReact';
import HotelLocation from './components/HotelLocation';

const ShowMoreButton = ({
  children,
  ...props
}: ComponentProps<typeof LinkButton>) => (
  <LinkButton noPadding {...props}>
    <Text fontSize="sm" fontWeight="bold">
      {children}
    </Text>
  </LinkButton>
);

const PackageOverview = () => {
  const propertyContent = usePropertyContent();
  const procuredOffer = useProcuredOffer();

  const tagline =
    procuredOffer?.highlights?.title ||
    procuredOffer?.offerDescription ||
    propertyContent?.tagline;

  const description =
    procuredOffer?.highlights?.description || propertyContent.description;

  return (
    <Container>
      <Flex
        pt={['6', null, '8']}
        pb="8"
        flexDirection={['column', null, 'row']}
        id="package-highlights"
      >
        <Box flex="1" mr={[null, null, '20']}>
          {tagline && (
            <Heading.h5 data-testid="PROPERTY_TAGLINE" pb="4">
              {tagline}
            </Heading.h5>
          )}

          {description && (
            <ReadMoreText ButtonComponent={ShowMoreButton} maxLines={6}>
              <Text
                data-testid="PROPERTY_DESCRIPTION"
                color="text.body"
                lineHeight="1.75"
                fontSize="sm"
              >
                {htmlToReact(description)}
              </Text>
            </ReadMoreText>
          )}
        </Box>
        <Box mt={['6', null, '0']} flex={[null, null, ['0 0 385px']]}>
          <HotelLocation />
        </Box>
      </Flex>
    </Container>
  );
};

export default PackageOverview;
